import(/* webpackMode: "eager" */ "/workspace/apps/ssv-home/src/app/design-guidelines/[group]/[asset]/page.tsx");
